import { Dispatch, SetStateAction, useState } from "react";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { IBill, IEntrega, IMachine, IObra, IOrcamento, IPeca } from "../IObra";
import PecaDisplay from "./PecasDisplay";
import EditIcon from '@mui/icons-material/Edit';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { GenerateFolhaObraModal } from "./GenerateFolhaObraModal";
import { PropDisplay, RoutableDisplay } from "../../../../components/PropDisplay";
import { BackArrow } from "../../../../components/CustomMiscellaneous/BackArrow";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import { useMutation } from "@tanstack/react-query";
import { genericDelete } from "../../../../services/api.service";
import toast from "react-hot-toast";
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { ConfirmationModal } from "../../../Common/Modals/ConfirmationModal";
import { EmailQuestionarioSatisfacao } from "./EmailQuestionarioSatisfacaoModal";


const datasExpedicao = (obra: IObra): string => {

    const entregas: IEntrega[] = obra.entregas;
    const pecasParaEntrega = entregas?.filter((entrega: any) => entrega.pecasParaEntrega?.length > 0).flatMap((entrega: any) => entrega.pecasParaEntrega);
    const expedicoes = pecasParaEntrega?.filter((peca: any) => peca.expedicoes.length > 0).flatMap((peca: any) => peca.expedicoes);
    if (expedicoes.length == 0 || !expedicoes) return "-";
    const datas = expedicoes.map((e: any) => e.data ? e.data.split('T')[0] : null).filter((d: any) => d);
    if (datas.length == 0) return "-";
    return datas.join(', ');
};


export function ObraDisplay({ obra, setEditing, refetch }: { obra: IObra, setEditing: Dispatch<SetStateAction<boolean>>, refetch: () => void }) {

    const [isFolhaRequested, setIsFolhaRequested] = useState(false);
    const [pecasExpanded, setPecasExpanded] = useState(false);
    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false);

    const [emailModalOpen, setEmailModalOpen] = useState(false);


    const navigate = useNavigate();
    const location = useLocation();

    const deleteMutation = useMutation(genericDelete(location.pathname), {
        onSuccess: () => {
            toast.success("Obra eliminada com sucesso");
            navigate(-1);
        },
        onError: () => {
            toast.error("Erro ao eliminar obra");
        }
    });

    return (<>
        <EmailQuestionarioSatisfacao refetch={refetch} isOpen={emailModalOpen} obraId={obra?.id} close={() => setEmailModalOpen(false)} />

        <ConfirmationModal isOpen={deleteConfirmationModalOpen} text={"Eliminar a entidade?"} onConfirm={() => deleteMutation.mutate(undefined)} onCancel={() => setDeleteConfirmationModalOpen(false)} />

        <GenerateFolhaObraModal isOpen={isFolhaRequested} obraId={obra?.id} entregas={obra.entregas} onCancel={() => setIsFolhaRequested(false)} />

        <BackArrow onClick={() => navigate(-1)} />
        <div className="border rounded-md shadow-md p-8 px-16 text-sm m-10">
            <h2 className="font-bold text-xl mb-4">Obra {obra.number}</h2>

            <PropDisplay prop={"Número"} value={obra.number} />

            <PropDisplay prop={"Cliente"} value={obra.client?.name} />

            <PropDisplay prop={"Nº Obra"} value={obra.number} />

            {/* <PropDisplay prop={"Orçamentos"} value={obra.orcamentos.map((o: IOrcamento) => o.billCode).join(', ')} /> */}
            <RoutableDisplay prop={"Orçamentos"} values={obra.orcamentos.map((o: IOrcamento) => ({ value: o.billCode, route: `/orcamentos/${o.id}` }))} />

            <PropDisplay prop={"Valor da obra"} value={`${obra.value} €`} />

            <PropDisplay prop={"Nota encomenda"} value={obra.orderNote} />

            <PropDisplay prop={"Quantidade de peças"} value={obra.partAmount.toString()} />

            <PropDisplay prop={"Máquinas"} value={obra.machines.map((m: IMachine) => m.ref).join(', ')} />

            <PropDisplay prop={"Duração total (h)"} value={obra.overallDurationInDays} />

            <PropDisplay prop={"Faturas"} value={obra.bills.map((b: IBill) => b.code).join(', ')} />

            <PropDisplay prop={"Datas reais de entrega"} value={obra.entregas.map((e: IEntrega) => e.realDeliveryDate).join(', ')} />

            <PropDisplay prop={"Datas de expedicao"} value={datasExpedicao(obra)} />

            <PropDisplay prop={"Estado"} value={obra.state} />

            <PropDisplay prop={"Questionário de satisfação enviado para o cliente"} value={`${obra.questionnaireSent ? 'Sim' : 'Não'}`} />


            <div className="mt-5">
                <div className="flex justify-between">
                    <div className="font-bold mb-2">Lista de peças</div>

                    <div className="cursor-pointer">
                        {pecasExpanded ? <UnfoldLessIcon onClick={() => setPecasExpanded(false)} /> : <UnfoldMoreIcon onClick={() => setPecasExpanded(true)} />}
                    </div>
                </div>
                {pecasExpanded ?
                    <>
                        {obra.pecas.map((p: IPeca, idx: number) =>
                            <PecaDisplay key={idx} peca={p} />
                        )}
                    </>
                    : <div className="flex border border-zinc-300 rounded-md p-3">
                        <div className="mr-2">
                            <span className="font-bold">Quantidade de referências:</span> {obra.pecas.length}
                        </div>
                        <div>
                            <span className="font-bold">Quantidade total de pecas:</span> {obra.pecas.reduce((prev: number, curr: IPeca) => prev + curr.amount, 0)}
                        </div>
                    </div>}
            </div>


            <div className="flex justify-end mt-5">
                {obra.state === "Entregue" ?
                    <CustomButtonSimple className="mr-3 bg-cyan-600 hover:text-cyan-600 hover:border-cyan-600" text="Enviar questionário de satisfação" onClick={() => setEmailModalOpen(true)} />
                    : null}

                <CustomButtonSimple className="mr-3 bg-cyan-600 hover:text-cyan-600 hover:border-cyan-600" Icon={AutoFixHighIcon} text="Gerar folha de obra" onClick={() => setIsFolhaRequested(true)} />
                <CustomButtonSimple className="mr-3" Icon={EditIcon} text="Editar" onClick={() => setEditing(true)} />
                <CustomButtonSimple Icon={DeleteIcon} text="Eliminar" onClick={() => setDeleteConfirmationModalOpen(true)} />
            </div>

        </div></>)

}